module.exports = __webpack_public_path__ + "static/media/bike shipment service from hyderabad.098fc75f.jpg";